import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output, Renderer2, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { NavController, Platform, PopoverController } from '@ionic/angular';
import { Apollo } from 'apollo-angular';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { AlertUserLikeListComponent } from 'src/app/alert-user-like-list/alert-user-like-list.component';
import { AppState } from 'src/app/app.service';
import { CordovaService } from 'src/app/cordova.service';
import { RoutineService } from 'src/app/daily-content-v2/routine.service';
import { I18n } from 'src/app/i18n.service';
import { MobileChatServiceService } from 'src/app/pages/mobile-chat-board/mobile-chat-service.service';
import { Path } from 'src/app/path/path-v2.model';
import { QuestionService } from 'src/app/question/question.service';
import { ReplyComponent } from 'src/app/reply/reply.component';
import { Reply } from 'src/app/reply/reply.model';
import { ReplyService } from 'src/app/reply/reply.service';
import { RoutineInfo } from 'src/app/routine-v2/routine-info.model';
import { RoutineV2Service } from 'src/app/routine-v2/routine-v2.service';
import { AnalyticsServiceService } from 'src/app/services/analytics-service.service';
import { SessionService } from 'src/app/session/session.service';
import { AttachmentUploaderComponent } from 'src/app/shared/attachment-uploader/attachment-uploader.component';
import { SpinnerService } from 'src/app/spinner.service';
import { TranslationService } from 'src/app/translation/translation.service';
import { WalletService } from 'src/app/wallet/wallet.service';
import { WINDOW } from 'src/app/window.service';
import { UserPublicProfileComponent } from '../../user-public-profile/user-public-profile.component';
import { expandOnEnterAnimation, fadeOutAnimation } from 'angular-animations';
import { trigger, state, style, AUTO_STYLE, transition, animate } from '@angular/animations';
const DEFAULT_DURATION=120;
import mixpanel from 'mixpanel-browser';
import { HomeUiService } from 'src/app/new-design/home-ui.service';
import { MobileChatBoardComponent } from 'src/app/pages/mobile-chat-board/mobile-chat-board.component';
import { KyperDataApiService } from 'src/app/services/kyper-data-api.service';

@Component({
  selector: 'app-habit-comment-list-web',
  templateUrl: './habit-comment-list-web.component.html',
  styleUrls: ['./habit-comment-list-web.component.scss'],
  animations: [
    expandOnEnterAnimation({ duration: 100 }),
    fadeOutAnimation({duration:100}),
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ]
})
export class HabitCommentListWebComponent implements OnInit {

  @Input() mode: string = "routine";
  @Input() isPreview: boolean;
  @Input() inverted: boolean = false;
  @Input() small = false;
  @Output() closed: EventEmitter<any>;
  @Output() itemSelected: EventEmitter<any>;
  @Output() onShowCommentList = new EventEmitter<any>();
  @Output() onTextClick = new EventEmitter<any>();
  @Output() onToggleLike = new EventEmitter<any>();
  @Output() onShowLikeList = new EventEmitter<any>();
  @Output() onComment = new EventEmitter<any>();
  @ViewChild('btn') btn: ElementRef;
  @ViewChild("uploader") uploader: AttachmentUploaderComponent;
  @ViewChild("replyBlock") replyBlock: ElementRef;
  @ViewChild("repliesContainer") repliesContainer: ElementRef;
  @ViewChild("textareaForFeeds") txtarea_post: ElementRef;
  @ViewChild('postContainer') postContainer;
  @ViewChild('replyComponent') replyComponent: ReplyComponent;
  @Input() data: any;
  @Input() focusSpecificCommentPost;
  @Input() isHomeRoute: boolean;
  @ViewChild('h1')
  h1: ElementRef;
  isTranslated;
  @ViewChild('textContainer') textContainer: ElementRef;
  flag;
  showComment=false;
  path: Path;
  rightState= false
  ishideComment: boolean = false;
  sortBy: string = "timestamp";
  replyText: string = "";
  cachedReplyText: string = ""; // LUMBA-1383
  attachmentUrl: string = null;
  errors: { answerError: false };
  replyTo: Reply = null;
  replyToComponent: ReplyComponent;
  replyToId: number;
  isLoading: boolean = false;
  replyOffset: number;
  selected: boolean = false;
  voteLoading: boolean = false;
  user: any;
  routine: RoutineInfo;
  tagName_id: number
  showReplies=false;
  dataOfUser: Observable<any>;
  namesData: any[]
  tempData: any
  state: boolean = false;
  animation = ['bounceIn'];
  isScrolledBottom: boolean = false
  textareaContentLength=0;
  color: string
  singleRoutineAnswer: any
  signleRoutine: any
  userDetails;
  public replies: Reply[]
  public repliesTree: any[] =[]
  public repliesIdsMap: Map<number, number>
  public masterRoutineAnswer: any
  isMobile: boolean
  isLoaded =true;
  recordsToShow;
  hideRecords
  fadeState
  public isCollapsed: boolean = false;
  public isCollapsable: boolean = false;
  page;
  options = [
    {
      label: 'Other',
      animations: ['expandCollapse']
    }
  ]
  replyCount = 0;
  apiReplyCount = 0;
  hasSubReplies = false;
  private _prevDataReplies: any = null;
  private _prevReplyCount: any = null;
  // Collapse state for loaded sub-replies (drives the [class.hide_comment] binding on
  // repliesContainer AND the reversible "See more comments" ⇄ "Hide comments" button). A plain
  // field — not the DOM class — so it's reliable regardless of whether the ViewChild is resolved.
  subRepliesCollapsed = false;
  pathRegistration
  constructor(
    private i18n: I18n,
    private apollo: Apollo,
    private router: Router,
    private appState: AppState,
    private toastrService: ToastrService,
    private questionService: QuestionService,
    private replyService: ReplyService,
    private translationService: TranslationService,
    private spinnerService: SpinnerService,
    private cordovaService: CordovaService,
    public sessionService: SessionService,
    private mobileService: MobileChatServiceService,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private toasterService: ToastrService,
    private walletService: WalletService,
    private routineV2Service: RoutineV2Service,
    private nav: NavController,
    private routineService: RoutineService,
    private _bottomSheet: MatBottomSheet,
    public platform: Platform,
    private analyticsService: AnalyticsServiceService,
    private keyboard: Keyboard,
    private popoverController:PopoverController,
    public render: Renderer2,
    public homeUiService: HomeUiService,
    private kyperService: KyperDataApiService,
    @Inject(WINDOW) private window: Window,
  ) {
    this.path = this.appState.get("currentPath");
    this.user = this.appState.get("currentUser");
    this.pathRegistration = this.appState.get("pathRegistration");
    this.page = 1;
    this.isMobile = this.appState.get('isMobile')
    this.appState.set('questionsLoaded', false)

  }

  ngOnInit() {
  
    this.isLoaded =false;

  if (this.data) {
    const data = {
      singleRoutine: this.data,
      mode: this.mode,
    };
    this.appState.set("singleRoutineFeed", data)
  }
    var dataOfRoutineFeeds = this.appState.get('singleRoutineFeed')
    this.singleRoutineAnswer = dataOfRoutineFeeds.singleRoutine
   
    this.mode = dataOfRoutineFeeds["mode"];
    this.appState.set("mode", this.mode);
    this.color = this.appState.get("routine_color")
    this.appState.set('oldActionPoints', this.walletService.actionPoints.value)
    this.routine = this.data
    console.log("🚀 ~ HabitCommentListWebComponent ~ ngOnInit ~ this.data:", this.data)
    console.log("🚀 ~ HabitCommentListWebComponent ~ ngOnInit ~ this.routine:", this.routine)
    this.data = this.data;
    this.singleRoutineAnswer =this.data;
    console.log("🚀 ~ HabitCommentListWebComponent ~ ngOnInit ~ this.singleRoutineAnswer:", this.singleRoutineAnswer)
    this.analyticsService.setScreen(AnalyticsServiceService.FULLROUTINE)
    this.appState.set('communityNotification', undefined)
    this.appState.set('notificationData', undefined)
    console.log("🚀 ~ HabitCommentListWebComponent ~ ngOnInit ~ this.isHomeRoute:", this.isHomeRoute)
    if (this.focusSpecificCommentPost?.id == this.data?.id && this.focusSpecificCommentPost?.type == this.data?.type && !this.isHomeRoute) {
    setTimeout(() => {
      this.postContainer?.nativeElement?.scrollIntoView({ behavior: "smooth", block: "nearest" });;
      // this.postContainer.nativeElement.scrollTop = 130;

      this.onCommentClick();
    }, 500)
    }
  }
showCommentData(data) {
  let user ={
    email: data?.email,
   first_name: data?.first_name,
   id: data?.user_id,
   imageUrl: data?.image_url,
   last_name: data?.last_name,
   user_bg_color: data?.userBgColor

  }
  this.userDetails = user;
   var level1
           if (this.focusSpecificCommentPost?.post?.id == this.data?.id &&this.focusSpecificCommentPost?.replyId && this.focusSpecificCommentPost?.replyId != undefined && (this.focusSpecificCommentPost?.post?.replies?.length>0 && this.focusSpecificCommentPost?.post?.replies[0]?.id== this.focusSpecificCommentPost?.replyId)) {
             if (this.focusSpecificCommentPost?.post?.replies?.length > 2) {
               level1 = this.focusSpecificCommentPost?.post?.replies?.slice(0,2)
             }
             else {
               level1 = this.focusSpecificCommentPost?.post?.replies
             }
           }
           else {
              level1 = data.replies;
           }
  if (level1) {

    var subReply = level1.filter(item => item.repliableId)
    level1.forEach((reply: any) => {
      if (!reply.replies) { reply.replies = []; }
      reply.timestamp = new Date(reply.createdAt);
      subReply?.forEach((element: any) => {
        if (element?.repliableId === reply.id && !reply.replies.some((r: any) => r.id === element.id)) {
          reply.replies.push(element);
          reply.replies = [...new Set(reply.replies)];
        }
      });
    });
    this.replyCount = data?.replyCount ?? data?.reply_count;
    this.repliesTree = level1.filter(reply => reply.id && reply.replyLevel === 1)
    this.repliesTree.forEach(reply => {
      if (!reply.subReplyCount) { reply.subReplyCount = reply.replies?.length ?? 0; }
    });
    this.hasSubReplies = this.repliesTree.some(reply => (reply.subReplyCount ?? 0) > (reply.replies?.length ?? 0));
    this._prevDataReplies = this.data?.replies;
    this._prevReplyCount = this.data?.replyCount ?? this.data?.reply_count;
    console.log("🚀 ~ HabitCommentListWebComponent ~ showCommentData ~ this.repliesTree:", this.repliesTree)
    this.isLoaded =true;
    this.appState.set('repliesLength', this.repliesTree?.length)
    let isCommentDeleted = this.appState.get('commentDeleted')
    if (isCommentDeleted) {
      this.appState.set('commentDeleted', false)
    }
  }
  // Default view is COLLAPSED per the product model: first 2 comments (1 on home route) with
  // sub-replies hidden; "See more comments" reveals everything. Harmless when there is nothing to
  // collapse (≤2 comments, no sub-replies) — hasMoreRepliesToLoad stays false.
  this.recordsToShow = this.isHomeRoute ? 1 : 2;
  this.subRepliesCollapsed = true;
  this.spinnerService.off()

}
  async ngDoCheck() {
    let isCommentDeleted = this.appState.get('commentDeleted')
    if (isCommentDeleted) {
      //this.page =1
      let id = this.appState.get('deletedPostId')
      // commentDeleted is a GLOBAL flag shared by every post's component instance. Only the post
      // that OWNS the deleted comment may consume + apply it — otherwise a different post's
      // instance consumes it and splices the deleting post's tree into its own data (habit comments
      // showing under a micro-action; the real post's delete never reflecting). Leave it set for
      // the owning instance if it isn't ours.
      const fromScreen = this.appState.get('deletedFromScreenContentId');
      if (id && this.ownsComment(id)) {
        this.appState.set('commentDeleted', undefined)
        this.appState.set('deletedFromScreenContentId', undefined)
        this.removeDeletedComment(id);
      } else if (id && fromScreen != null && this.data?.screenContentId === fromScreen && !this.dataHasComment(id)) {
        // The delete targeted THIS post (screenContentId match) but the comment isn't in our loaded
        // tree AND is no longer in the shared feed data — an unloaded sub-reply, or already spliced by
        // a sibling tab. There's nothing to remove, so consume the signal here rather than leave it set
        // forever. Scoped to our post + gated on the comment being gone, so we never clear another
        // post's — or an owner's still-pending — delete.
        this.appState.set('commentDeleted', undefined)
        this.appState.set('deletedFromScreenContentId', undefined)
      }

      //await this.getRoutineDetails(null,true)
    }
    // Every community tab (All / Questions / Micro-actions / Habits) binds the SAME feed post
    // object as `data`, but each tab is a separate component instance with its own repliesTree
    // built once at init. When a sibling tab optimistically adds or deletes a comment it mutates
    // the shared data.replies (new array ref for a top-level comment/delete) and data.replyCount
    // (+/-1 for a sub-reply). Re-derive our tree whenever either changes so the update shows on
    // tab switch without reopening the community.
    const replies = this.data?.replies;
    const count = this.data?.replyCount ?? this.data?.reply_count;
    if (replies && (replies !== this._prevDataReplies || count !== this._prevReplyCount)) {
      this._prevDataReplies = replies;
      this._prevReplyCount = count;
      this.rebuildRepliesTreeFromData();
    }
  }

  /**
   * Re-derive repliesTree/replyCount/hasSubReplies from the shared `data.replies`. Handles both a
   * flat list (level-2 sub-replies carrying repliableId, as the server first sends) and an
   * already-nested tree (as sibling tabs mutate it) — the id de-dup keeps it idempotent, so
   * multiple tab instances rebuilding off the same shared objects never double-nest.
   */
  private rebuildRepliesTreeFromData() {
    const level1 = this.data?.replies ?? [];
    const subReplies = level1.filter((item: any) => item?.repliableId);
    level1.forEach((reply: any) => {
      if (!reply.replies) { reply.replies = []; }
      if (!reply.timestamp && reply.createdAt) { reply.timestamp = new Date(reply.createdAt); }
      subReplies.forEach((element: any) => {
        if (element?.repliableId === reply.id && !reply.replies.some((r: any) => r.id === element.id)) {
          reply.replies.push(element);
        }
      });
    });
    this.repliesTree = level1.filter((reply: any) => reply.id && (reply.replyLevel === 1 || reply.level === 1));
    this.repliesTree.forEach((reply: any) => {
      if (reply.subReplyCount == null) { reply.subReplyCount = reply.replies?.length ?? 0; }
    });
    this.replyCount = this.data?.replyCount ?? this.data?.reply_count ?? this.replyCount;
    this.hasSubReplies = this.repliesTree.some((r: any) => (r.subReplyCount ?? 0) > (r.replies?.length ?? 0));
    if (this.singleRoutineAnswer) {
      this.singleRoutineAnswer.replies = this.repliesTree;
      this.singleRoutineAnswer.replyCount = this.replyCount;
    }
  }

  /**
   * Record the current shared data.replies/replyCount as the last state THIS instance produced, so
   * its own optimistic add / delete / "see more" fetch does not trip the ngDoCheck cross-tab
   * re-derive — that would clobber the locally-managed recordsToShow / check / apiReplyCount paging
   * state and wrongly light up the "See more comments" / "See More" / "Hide comments" buttons. Only
   * a change made by ANOTHER tab instance leaves _prev stale and triggers a rebuild here.
   */
  private markRepliesSynced() {
    this._prevDataReplies = this.data?.replies;
    this._prevReplyCount = this.data?.replyCount ?? this.data?.reply_count;
  }

  /** True when the given deleted-comment id belongs to THIS post — as a top-level comment or a
   *  loaded sub-reply. Used to scope the global commentDeleted flag to the owning post only. */
  private ownsComment(id: any): boolean {
    const tree = this.repliesTree ?? [];
    return tree.some((r: any) => r?.id === id) ||
           tree.some((r: any) => r?.replies?.some((s: any) => s?.id === id));
  }

  /** True if `id` is still present anywhere in the shared feed data — top-level comment or sub-reply —
   *  in either the flat (server) or nested (locally-mutated) shape of data.replies. Lets ngDoCheck
   *  tell "an owner still has to splice this" (keep the flag) from "already gone / never loaded"
   *  (safe to consume the flag). */
  private dataHasComment(id: any): boolean {
    const replies = this.data?.replies ?? [];
    return replies.some((r: any) => r?.id === id || (r?.replies ?? []).some((s: any) => s?.id === id));
  }

removeDeletedComment(id) {
  if (id) {
      let deletedReply;
      console.log("replies tree before deleting", this.repliesTree, this.appState.get('repliesTreeObject'));
    // Splice from THIS post's OWN rendered tree. ngDoCheck only calls this when the deleted comment
    // actually belongs to this post (see the ownsComment guard), so we never adopt another post's
    // tree via repliesTreeObject — that let one post's instance clobber a different post's
    // data.replies (habit comments appearing under a micro-action, etc.), and a null snapshot crashed.
    this.repliesTree = this.repliesTree ?? [];
    if (this.replyCount == 0) {
      this.replyCount = Number(this.data?.replyCount ?? this.data?.reply_count ?? this.replyCount);
    }
    deletedReply = this.repliesTree?.findIndex((reply) => reply?.id === id);
    // Count the sub-replies that die with the parent from the TRUE total, not the loaded subset.
    // `replies` is empty while collapsed (sub-replies lazy-load) and `?? ` does NOT fall back on 0 —
    // so this under-decremented replyCount, leaving a phantom "1 more on the server" that kept a dead
    // "See more comments" button on screen and fetched nothing when clicked.
    const target: any = this.repliesTree[deletedReply];
    let deletedIdCount = Math.max(
      target?.replies?.length ?? 0,
      target?.subReplyCount ?? 0,
      target?.sub_reply_count ?? 0
    );
      if (deletedReply != -1 && deletedReply != undefined) {
        this.repliesTree.splice(deletedReply, 1);
        this.replyCount = Math.max(0, this.replyCount - (deletedIdCount + 1));
         if (this.apiReplyCount > 0) {
          this.apiReplyCount -= (deletedIdCount + 1);
        }
        //this.getRoutineDetails((deletedPost/10)+1);
      } else {
        for (const reply of this.repliesTree) {
          deletedReply = reply?.replies?.findIndex((reply) => reply?.id === id);
          if (deletedReply != -1 && deletedReply != undefined) {
            reply?.replies?.splice(deletedReply, 1);
            // Decrement the TOTAL rather than resetting to the loaded count: with lazily-loaded
            // sub-replies (loaded < total) a reset would drop the badge to the loaded subset.
            reply.subReplyCount = Math.max(reply.replies?.length ?? 0, (reply.subReplyCount ?? 0) - 1);
            this.replyCount = Math.max(0, this.replyCount - 1);
            if (this.apiReplyCount > 0) {
              this.apiReplyCount -= 1;
            }
          }
        }
      }
    this.hasSubReplies = this.repliesTree.some((r: any) => (r.subReplyCount ?? 0) > (r.replies?.length ?? 0));
    this.singleRoutineAnswer.replies = this.repliesTree;
    this.data.replies = [...this.repliesTree];
    this._prevDataReplies = this.data.replies;
    this.data.replyCount = this.replyCount;
    this._prevReplyCount = this.data.replyCount;
    this.singleRoutineAnswer.replyCount = this.replyCount;
    //  if (this.apiReplyCount<=2) {
    //     this.select(true);
    //   }
      console.log("deleted post", deletedReply, this.repliesTree);
      this.appState.set('deletedPostId',null)
      this.backfillPreviewAfterDelete();
    }
  }

  /**
   * Deletes drain the loaded tree, but the collapsed view only ever loaded the first page. Deleting
   * the previewed comments could leave an EMPTY list still showing "See more comments" — the user saw
   * no comments at all and had to click to reveal a comment that was there all along. Refetch when the
   * remaining loaded comments no longer fill the collapsed preview and the server still holds more, so
   * the preview always backfills to the next comment(s) instead of going blank.
   */
  private backfillPreviewAfterDelete() {
    const tree = this.repliesTree ?? [];
    const preview = this.isHomeRoute ? 1 : 2;
    const loadedTotal = tree.reduce((sum, r: any) => sum + 1 + (r?.replies?.length ?? 0), 0);
    if (tree.length < preview && loadedTotal < (this.replyCount ?? 0)) {
      this.page = 1;
      this.getAllReplies(undefined, true);
    }
  }
  ngAfterViewInit() {
    this.focusComment()
    window.scroll(0, 0);
    if(this.isMobile){
      if(this.platform.is('android')) {
       let id =document.getElementsByClassName('list-group')[0];
       id.setAttribute('style', 'margin-top:60px;')
        this.keyboard.onKeyboardDidShow().subscribe((info) => {
          this.replyBlock?.nativeElement?.style.setProperty(
            'bottom',
            `${info.keyboardHeight-20}px`
          );
          this.replyBlock?.nativeElement?.style.setProperty(
            'padding-bottom',
            `${276-(info.keyboardHeight-20)}px`
          );
        });
    
        this.keyboard.onKeyboardDidHide().subscribe(() => {
          this.replyBlock?.nativeElement?.style.setProperty(
            'bottom',
            `${0}px`
          );
          this.replyBlock?.nativeElement?.style.setProperty(
            'padding-bottom',
            `${0}px`
          );
        });
      }
    }
    if (!this.isMobile && !this.isHomeRoute) {
      if (this.focusSpecificCommentPost?.isFocus == false && this.focusSpecificCommentPost?.post?.id == this.data?.id) {
        setTimeout(() => {
          this.postContainer?.nativeElement?.scrollIntoView({ behavior: "smooth", block: "nearest" });
          // this.postContainer.nativeElement.scrollTop = 130;
        },500)
        
      }
    }
  if(this.isHomeRoute) {
    setTimeout(() => {
      const container = this.textContainer?.nativeElement;
      const lineHeight = parseFloat(window.getComputedStyle(container).lineHeight);
      const containerHeight = container.clientHeight;  
      const lineCount = Math.floor(containerHeight / lineHeight);
         if (lineCount > 5) {
            this.isCollapsed = true;
            this.isCollapsable = true;
            let el = document.getElementsByClassName('text')[0]
            this.render.addClass(this.textContainer?.nativeElement, 'expand-texts');
         }
    },500)
  }
    console.log("called showCommetData");
    this.showCommentData(this.data)
    console.log("🚀 ~ HabitCommentListWebComponent ~ ngAfterViewInit ~ this.data:", this.data)
  }
  onCommentClickInHome(event,singleRoutineAnswer) {
    event.stopPropagation();
    this.homeUiService.openNextComponent(MobileChatBoardComponent, {data:singleRoutineAnswer},'desktop-custom-modal')
  }
  onCommentClick(ev?,singleRoutineAnswer?) {
    if (!this.isHomeRoute) {   
      this.showReplies = false;
      this.replyTo = null;
      this.replyToId = null;
      this.showComment = !this.showComment;
      if (this.showComment) {
        if (!this.isMobile) {
          this.replyService.setPropertyValue(true);

        }
        setTimeout(() => {
          this.txtarea_post?.nativeElement?.focus();
        }, 500);
      }
      else {
        if (!this.isMobile) {
          this.replyService.setPropertyValue(null);

        }
      }
    }   
    else {
         this.onCommentClickInHome(ev, singleRoutineAnswer)
    }
  }
  // ── Collapse model (single source of truth) ────────────────────────────────
  // `subRepliesCollapsed` is the ONE collapse flag. `check` is DERIVED from it (never stored), so
  // the two can never drift out of sync. Collapsed = the 2-comment preview with sub-replies hidden;
  // expanded (check) = all comments + sub-replies shown. Transitions only ever set subRepliesCollapsed.
  get check(): boolean { return !this.subRepliesCollapsed; }

  // There is content the toggle would reveal — used by BOTH the collapsed "See more comments"
  // (!check) and the expanded "See More" (check) buttons. Derived purely from state so it is always
  // consistent no matter how a transition (add / delete / expand / collapse / sibling sync) left it.
  get hasMoreRepliesToLoad(): boolean {
    const tree = this.repliesTree ?? [];
    const cap = this.recordsToShow ?? tree.length;
    const hiddenComments = tree.length > cap;
    const loadedTotal = tree.reduce((sum, r) => sum + 1 + (r?.replies?.length ?? 0), 0);
    const moreOnServer = loadedTotal < (this.replyCount ?? 0);
    const loadedSubRepliesHidden = this.subRepliesCollapsed && tree.some((r: any) => (r?.replies?.length ?? 0) > 0);
    const pendingSubReplies = tree.some((r: any) => (r?.subReplyCount ?? 0) > (r?.replies?.length ?? 0));
    return hiddenComments || moreOnServer || loadedSubRepliesHidden || pendingSubReplies;
  }

  // Collapsing is only meaningful when the expanded view shows MORE than the collapsed preview
  // would (the first `preview` comments with sub-replies hidden). Gates the "Hide comments" button
  // so it disappears once deletes bring the list down to ≤ preview with no sub-replies.
  get canCollapse(): boolean {
    const tree = this.repliesTree ?? [];
    const preview = this.isHomeRoute ? 1 : 2;
    return tree.length > preview || tree.some((r: any) => (r?.replies?.length ?? 0) > 0);
  }

  showRecords() {
    let count = this.repliesTree.length-this.recordsToShow;
    this.hideRecords =this.recordsToShow;
    if(count>=10) {
     this.recordsToShow = this.recordsToShow+10;
    }
    else {
     this.recordsToShow = this.recordsToShow+count;
    }
   }
   // "See More" (expanded): reveal the next 10 comments. If more are already loaded than are shown,
   // just widen the client-side window (getAllReplies' server fetch returns nothing when everything
   // is already loaded, so it would otherwise do nothing). Only hit the server when we need more.
   seeMore() {
     const loaded = this.repliesTree?.length ?? 0;
     if (loaded > (this.recordsToShow ?? 0)) {
       this.showRecords();
       this.cdRef.detectChanges();
     } else {
       this.getAllReplies(true);
     }
   }
   // "See more comments" (collapsed → expand). Expand immediately so the view opens even when
   // everything is already loaded: a server fetch would then return no new rows and getAllReplies
   // only calls select() when it got rows, so the view would otherwise stay stuck collapsed. Fetch
   // from the server only when it actually holds more than we've loaded (it expands on success).
   seeMoreComments() {
     const loadedTotal = (this.repliesTree ?? []).reduce((sum, r: any) => sum + 1 + (r?.replies?.length ?? 0), 0);
     if (loadedTotal < (this.replyCount ?? 0)) {
       this.getAllReplies(false);
     } else {
       this.select(false);
     }
   }
   // The one collapse toggle. val=false → "See more comments" (expand: all comments + sub-replies).
   // val=true → "Hide comments" (collapse back to the 2-comment preview with sub-replies hidden).
   select(val) {
     this.hideRecords = 0;
     if (!val) {
       this.subRepliesCollapsed = false;                    // reveal sub-replies (check becomes true)
       // Show the first 10 comments when there are more than 10 (so "See More" reveals the next 10 —
       // the client-side 10-at-a-time paging). Only uncap when 10 or fewer are loaded.
       const loaded = this.repliesTree?.length ?? 0;
       this.recordsToShow = loaded > 10 ? 10 : loaded;
       this.cdRef.detectChanges();
     } else {
       this.subRepliesCollapsed = true;                     // hide sub-replies (check becomes false)
       this.recordsToShow = this.isHomeRoute ? 1 : 2;       // back to the preview cap (1 on the home route)
       this.page = 1;
       this.apiReplyCount = 0;
       // Apply the collapse to the DOM BEFORE scrolling. The smooth scrollIntoView animates toward
       // #postContainer's position at call time; if we scroll while the thread is still expanded, the
       // collapse (display:none on sub-replies + slicing back to 2 comments) then shrinks the document
       // under the in-flight animation and it overshoots onto a neighbouring, still-expanded post.
       // Collapsing first makes the smooth scroll settle on THIS post's final collapsed position.
       this.cdRef.detectChanges();
       this.postContainer?.nativeElement?.scrollIntoView({ behavior: "smooth", block: "nearest" });
       if (this.postContainer?.nativeElement) { this.postContainer.nativeElement.scrollTop = 0; }
     }
   }
  itemMentioned(tag) {
    console.log("selected ", tag);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.routine || changes.routine.firstChange) {
      return false;
    }
    this.sortRepliesBy(this.sortBy)
    this.cdRef.detectChanges();
  }

  toggleSort(by: string) {
    console.log("by:" + by);
    this.sortBy = by;
    this.sortRepliesBy(this.sortBy)
  }
  orderingSubReplies(reply) {
    var level1 = [reply, ...this.repliesTree];
    let replySort;
    this.data.replyCount = this.data.replyCount + 1;
    this.replyCount = this.data.replyCount;
    if (level1) {
      var subReply = level1.filter(item => item.repliableId)
      level1?.forEach(reply => {
        subReply?.forEach(element => {
         if (element?.repliableId === reply.id) {
            const updatedReply = { ...reply };
            updatedReply.replies = [element, ...updatedReply.replies];
            updatedReply.timestamp = new Date(reply.createdAt);
            //replySort =updatedReply;
            const index = level1.findIndex(r => r.id === updatedReply.id);
            level1[index] = updatedReply;
          }
        });
      });
      this.isLoaded = true;
    //   if (replySort) {
    //     replySort.timestamp = new Date(reply.createdAt);
    //   }
    //  let index =level1?.findIndex((reply) => reply.id == replySort.id)
    //   level1.splice(index,1)
      let repliesTree = level1.filter(reply => reply.id && (reply.replyLevel === 1 || reply.level === 1))
      this.repliesTree = repliesTree;
      this.data.replies = this.repliesTree;
    }
  }
  replyFun(text?) {
    if(this.textareaContentLength>0){
      this.isLoaded =false
    }
    if(text) {
      this.replyText =text.replyText;
    }
    if(!this.isMobile) {
      this.replyService.setPropertyValue(null);

    }
      this.showComment = false;
    this.showReplies =false;
    
    let formatedText;
    if (this.replyText.length == 0) {
      this.toastrService.error(this.i18n.t('Please enter a comment'), this.i18n.t('Error'))
      return false;
    }

    var list_of_tags_ids = []

    list_of_tags_ids = this.sessionService.getUserTAGs(this.replyText, this.complexItems)
     list_of_tags_ids = list_of_tags_ids.filter(userId => userId !== this.user?.id)
    mixpanel.track('Community-web-Comment reply', {'Comment post': this.replyText, 'post id': this.repliesTree[0]?.id, 'post text': this.repliesTree[0]?.text, 'post userId': this.repliesTree[0]?.user?.id, 'post type': this.repliesTree[0]?.type, 'post vote': this.repliesTree[0]?.hasVoted })
    console.log("Array of tags ", list_of_tags_ids);

    // if (this.isPreview) {
    //   return false
    // }
    // if (this.isLoading) {
    //   return false
    // }
    this.isLoading = true
    this.complexItems?.forEach(element => {
      const username = element.username.toString().trim();
      const formattedUsername = username
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
      const exactMention = `@${formattedUsername}`;
      const regex = new RegExp(`(?<!\\w)${exactMention}(?!\\w)`, 'g');
      if (regex.test(this.replyText)) {
        const replaceValue = `<span id="${element.id}"><strong id="${element.id}">${formattedUsername}</strong></span>`;
        formatedText = this.replyText.replace(regex, replaceValue);
      }
    });
    this.unloadReply();
    if (formatedText) {
      this.cachedReplyText = formatedText;
    }
    if (this.replyTo) {
      this.isLoaded = true;
      console.log("🚀 ~ CommentsListWebComponent ~ replyFun ~ this.data:", this.data)
      let userIdsToNotify = list_of_tags_ids?.length > 0 
        ? list_of_tags_ids 
        : (this.replyTo?.user?.id === this.user?.id || this.replyTo?.user?.id === this.user?._data?.id) 
          ? [] 
          : [this.replyTo?.user?.id];
      let input = {
          screen_content_id: this.data?.screenContentId,
          root_id: this.replyTo.id,
          reply_text: this.cachedReplyText,
          reply_type: "habit_sub_reply",
          reply_level: 2,
          user_ids: userIdsToNotify,
          comment_type:list_of_tags_ids?.length>0?'tag':'comment',
          is_translate: this.appState.get('selectedLanguage')? true:false
        }
        this.kyperService.postKyperUserReplies(input).subscribe((res) => {
                   console.log("🚀 ~ CommentsListWebComponent ~ replyFun ~ res:", res)
                   this.ishideComment = true;
                this.showReplies =false;
                this.reset();
                this.isLoading = false;
                this.showComment = false;
                const parentReplyId = this.replyTo.id;
                this.replyTo = null;
                this.replyToId = null;
                this.toastrService.success(
                  this.i18n.t("Comment posted!")
                );
                this.appState.set('isCommentPosted',true)
                this.appState.set('isReplyAnimationApplied',true);
                const normalizedSubReply = this.normalizeLevel2Reply(res.data);
                // When sub-replies are collapsed they aren't loaded inline — only the count badge
                // (subReplyCount) is shown. Injecting the new one here would (a) render a lone sub-reply
                // inside the collapsed preview and (b) drop the badge to the loaded count (1) instead of
                // the true total, because the badge shows replies.length once anything is loaded. So
                // while collapsed we only bump the parent's total; expanding ("See more comments")
                // reloads and shows it. When already expanded, insert it inline as before.
                if (this.subRepliesCollapsed) {
                  const parent = this.repliesTree?.find((r: any) => r?.id === parentReplyId);
                  if (parent) { parent.subReplyCount = (parent.subReplyCount ?? 0) + 1; }
                } else {
                  this.repliesTree = this.insertLevel2Reply(parentReplyId, normalizedSubReply, this.repliesTree);
                }
                this.data.replies = this.repliesTree;
                this.data.replyCount = (this.data.replyCount ?? this.replyCount ?? 0) + 1;
                this.replyCount = this.data.replyCount;
                // Keep singleRoutineAnswer (the object the host card/full-screen view binds its count
                // to) in step, the same way rebuildRepliesTreeFromData/removeDeletedComment do. It is
                // the same reference as `data` today, but updating it explicitly keeps the count correct
                // if they ever diverge.
                if (this.singleRoutineAnswer) {
                  this.singleRoutineAnswer.replies = this.repliesTree;
                  this.singleRoutineAnswer.replyCount = this.replyCount;
                }
                this.markRepliesSynced();
                console.log("🚀 ~ CommentsListWebComponent ~ replyFun ~ this.data.replies:", this.data.replies)
                this.isLoaded = true;
                 this.isLoading = true;
                this.loadReply();
                this.cdRef.detectChanges();
                // Clear the textarea of the comment we actually replied to (not the first reply block via
                // the #replyComponent ViewChild), so reopening its reply box shows a blank textarea
                // instead of the just-posted text.
                const repliedComponent = text ?? this.replyToComponent;
                if (repliedComponent) {
                  repliedComponent.replyText = '';
                  repliedComponent.textareaContentLength = 0;
                }
                if (this.repliesContainer != undefined) {
                  this.postContainer.nativeElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
                  this.postContainer.nativeElement.scrollTop = 0;
                }
        }, (error) => {
                console.log(error);
                this.loadReply();
                this.isLoaded = true;
                this.toastrService.error(
                  this.i18n.t("Comment not posted. Check your connection and try reloading the app."),
                  this.i18n.t("Error")
                );
                this.isLoading = false;
              this.cdRef.detectChanges();   
        })
    } else {
      console.log("🚀 ~ CommentsListWebComponent ~ replyFun ~ this.data:", this.data)
      // The backend only pushes to user_ids, so without tags the habit owner must be added
      // explicitly (same as sub-replies do for the replied-to user), unless they're commenting on their own habit.
      let userIdsToNotify = list_of_tags_ids?.length > 0
        ? list_of_tags_ids
        : (!this.data?.user_id || this.data?.user_id === this.user?.id || this.data?.user_id === this.user?._data?.id)
          ? []
          : [this.data?.user_id];
      let input = {
          step_id: this.data?.stepId,
          screen_id: this.data?.screenId,
          screen_content_id: this.data?.screenContentId,
          answer_text: this.cachedReplyText,
          is_translate: this.appState.get('selectedLanguage')? true:false,
          user_ids: userIdsToNotify,
          comment_type: list_of_tags_ids?.length > 0 ? 'tag' : 'comment',
          habit_id: this.data?.habit_id,
          habit_user_id: this.data?.user_id
        }
        this.kyperService.postKyperUserComment(input).subscribe((res) => {
                   this.appState.set('currentActionPoints', res?.data?.replyQuestion?.actionPoints)
                    this.ishideComment = true;
                    this.reset()
                    this.isLoading = false
                    this.showReplies = false;
                    this.appState.set('isAnimationApplied',true);
                    this.replyTo = null;
                    this.replyToId = null;
                    this.isLoaded = true;
                    const normalizedReply = this.normalizeLevel1Reply(res.data);
                    this.repliesTree = [normalizedReply,...(this.repliesTree ?? [])];
                    this.data.replies = this.repliesTree;
                     this.data.replyCount = this.data.replyCount+1;
                    this.replyCount = this.data.replyCount;
                    // Keep singleRoutineAnswer (the count binding on the host card/full-screen view) in
                    // step with the optimistic add — same reference as `data` today, explicit for safety.
                    if (this.singleRoutineAnswer) {
                      this.singleRoutineAnswer.replies = this.repliesTree;
                      this.singleRoutineAnswer.replyCount = this.replyCount;
                    }
                    // Grow the visible window by the one just-added comment so it appears WITHOUT
                    // pushing any previously-visible comment out of the slice(0, recordsToShow)
                    // preview (which otherwise reads as an auto-collapse / stray "See More"). If the
                    // list was uncapped (null) it stays showing all.
                    this.recordsToShow = (this.recordsToShow == null) ? this.repliesTree.length : this.recordsToShow + 1;
                    this.markRepliesSynced();
                    this.loadReply()
                    this.isLoading = true;
                    this.cdRef.detectChanges()
                    this.toastrService.success(this.i18n.t('Comment posted!'))
        }, (error) => {
                console.log(error)
                this.loadReply()
                this.cdRef.detectChanges()
                this.isLoaded = true;
                this.toastrService.error(this.i18n.t('Comment not posted. Check your connection and try reloading the app.'), this.i18n.t('Error'))
                this.isLoading = false  
        })
    }
  }

  normalizeLevel1Reply(raw: any): any {
    return {
      id: raw.questionId ?? raw.id ?? Date.now(),
      replyText: raw.replyText ?? raw.answerText,
      replyLevel: 1,
      replyType: raw.replyType ?? 'action_reply',

      pathId: raw.pathId,
      stepId: raw.stepId ?? null,
      screenId: raw.screenId,
      screenContentId: raw.screenContentId,

      likes: [],
      replies: [],
      reply_count: 0,
      hasVoted: false,
      subReplyCount: 0,

      userId: raw.userId,
      user: raw.user ?? this.user,              // current logged-in user

      createdAt: raw.createdAt ?? new Date().toISOString(),
      timestamp: new Date()
    };
  }

  normalizeLevel2Reply(raw: any): any {
    return {
      id: raw.id,
      replyText: raw.replyText ?? raw.reply_text,
      replyLevel: 2,
      replyType: raw.replyType,

      pathId: raw.pathId,
      screenContentId: raw.screenContentId,
      rootId: raw.rootId ?? raw.root_id,

      likes: [],
      replies: [],

      replyVotesCount: 0,
      hasVoted: false,

      userId: raw.userId,
      user: raw.user ?? this.user,

      createdAt: raw.createdAt ?? new Date().toISOString(),
      timestamp: new Date()
    };
  }

  insertLevel2Reply(parentReplyId: number, subReply: any, repliesTree: any[]): any[] {
     this.isLoaded =true;
    this.appState.set("isMobileReply", false);
    // this.data.replyCount = this.data.replyCount+1;
    for (const reply of repliesTree) {
    if (reply.id === parentReplyId) {
      reply.replies = reply.replies || [];
      reply.replies.unshift(subReply);
      // Increment the total rather than resetting to replies.length: when sub-replies were lazily
      // loaded (loaded < total), replies.length is only the loaded subset, so resetting would drop
      // the badge (e.g. 2 -> 1). One more sub-reply == one more on the total.
      reply.subReplyCount = (reply.subReplyCount ?? 0) + 1;
      return repliesTree;
    }
    }

    return repliesTree;
  }

  translate($event){
    let toggleEnabled = $event.detail.checked

    if (toggleEnabled === true) {
      this.isTranslated =true;
      this.flag =false;
      this.path = this.appState.get("currentPath");
      const repliesIds = this.repliesTree.map((reply) => reply.id);
      this.translationService
        .loadRepliesTranslations(repliesIds, this.path.language)
        .subscribe((translations) => {
          this.repliesTree.forEach((reply) => {
            const key = `Reply:${reply.id}`;
            reply.text = translations[key].text;
            this.isTranslated =false;
            this.flag = true
            this.cdRef.detectChanges()
          });
        });
    }

    else {
      this.flag = false;
      this.appState.set('commentDeleted', true)
      this.cdRef.detectChanges()
    }
  }

  reset() {
    this.replyText = "";
    this.attachmentUrl = null;
    if (this.uploader) {
      this.uploader.reset();
    }
    this.cachedReplyText = "";
  }

  // LUMBA-1383
  loadReply() {
    if (this.cachedReplyText) {
      this.replyText = this.cachedReplyText;
      this.cachedReplyText = "";
    }
  }

  // LUMBA-1383
  unloadReply() {
    this.cachedReplyText = this.replyText;
    this.replyText = "";
  }
  checkTextareaLength() {
    let len = this.replyText?.trim();
   this.textareaContentLength =len?.length;
}
  setReplyTo(replyComponent: ReplyComponent) {
    if (this.uploader) {
      this.uploader.reset();
    }
    this.showReplies =true ;
    // This code was needed when all replies was visible
    // Now all replies hidden except selected for reply
    if (this.replyToComponent) {
      //this.replyToComponent.selected = false;
    }
    this.showComment=false
    if(replyComponent?.selected){
    
      if(this.showReplies) {
        setTimeout(()=>
        {this.txtarea_post?.nativeElement.focus();
        },500);    }
    }
    else {
      this.showReplies =false;
    }
    this.replyToComponent = replyComponent;
    if (replyComponent) {
      this.replyTo = replyComponent.reply;
      this.replyToId = this.replyTo.id;
    } else {
      this.replyTo = null;
      this.replyToId = null;
    }
  }

  refresh() {
    console.log(this.router.url);
    this.apollo.getClient().clearStore();
    this.appState.refreshMainComponent.emit();
  }

  scrollTo(event) {
    if (this.cordovaService.onCordova) {
      console.log("click event");
      console.log(this.replyBlock?.nativeElement.offsetTop);

      setTimeout(() => {
        window.scrollTo({
          top: this.replyBlock?.nativeElement.offsetTop - 160,
          behavior: "smooth",
        });
      }, 10);
    }
  }

  close() {
    this.rightState=true;
    this.dialog.closeAll();

  }

  totalLikes(items) {
    return items.reduce((a, b) => +a + +b.replyVotesCount, 0);
  }

  clickOnInput() {
    this.txtarea_post?.nativeElement.focus();
  }

  toggleVote(reply) {
  console.log("🚀 ~ HabitCommentListWebComponent ~ toggleVote ~ reply:", reply)

    this.bounceAnimation()
    if (this.isHomeRoute) {
      this.doLikeUnlike();
    }
    else {
      this.mobileService.setIsLikeList(true)
      this.mobileService.setPostId(reply?.id)
      this.mobileService.setMode(this.mode)
      this.voteLoading = true;
      reply.hasVoted = !reply.hasVoted;
      console.log("🚀 ~ HabitCommentListWebComponent ~ toggleVote ~ reply.hasVoted:", reply.hasVoted)
      // reply.replyVotesCount += reply.hasVoted ? 1 : -1;
      if(!reply.replyVotesCount) {
      reply.replyVotesCount =0
    }
    reply.replyVotesCount += reply.hasVoted ? 1 : -1
      console.log("🚀 ~ HabitCommentListWebComponent ~ toggleVote ~ reply.replyVotesCount:", reply.replyVotesCount)
      if (reply.hasVoted) {
        reply.likes?.push(this.user?._data);
        this.data.likes = reply.likes;
      }
      else {
        reply.likes?.forEach((user, index) => {
          if (user.id === this.user?._data.id)
            reply.likes?.splice(index, 1);
        });
        this.data.likes = reply.likes;
      }
      this.cdRef.detectChanges();
      let likesData = {
        // user_id: this.user.id,
        path_id: this.path.id,
        post_id: reply.id,
        screen_content_id: reply.screenContentId
      }
      console.log("🚀 ~ HabitCommentListWebComponent ~ toggleVote ~ likesData:", likesData)
      this.kyperService.postKyperUserLikes(likesData).subscribe({
        next: (res) => {
          console.log("🚀 ~ HabitCommentListWebComponent ~ toggleVote ~ res:", res)
          reply.hasVoted = res.data.voteStatus;
          reply.replyVotesCount = res.data.totalLikes;
          this.cdRef.detectChanges();
        },
        complete: () => {
          this.voteLoading = false;
          this.cdRef.detectChanges();
        },
        error: () => {
          this.voteLoading = false;
        }
      });
    }  
  }

  complexItems = this.appState.get("userlist")

  tempValue = 0
  index = 0

  format(item: any) {
    var data = item['id']
    setTimeout(() => {
      SessionService.setData(data)
      console.log("Format data ", SessionService.getData());
    }, 100);
    const username = item['username'].toString();
    const formattedUsername = username
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    return `@${formattedUsername}`;
  }

  mentionConfig: any = {
    mentions: [
      {
        items: this.complexItems,
        labelKey: 'username',
        mentionSelect: this.format,
        dropUp: true
      }
    ]
  };


  focusComment() {
    if (this.appState.get('commentClicked')) {
      this.appState.set('commentClicked', false)
        this.txtarea_post?.nativeElement.focus();
     
    }
    else {
      this.txtarea_post?.nativeElement.blur();
    }
  }

  bounceAnimation() {
    this.render.addClass(this.btn?.nativeElement, 'bounce');
    if(this.btn?.nativeElement.querySelector('ion-icon').getAttribute("name") == 'star-outline') {
      this.render.setAttribute(this.btn?.nativeElement.querySelector('ion-icon'),"name", 'star')
    }
    else {
      this.render.setAttribute(this.btn?.nativeElement.querySelector('ion-icon'),"name", 'star-outline')

    }
    setTimeout(() => {
      this.render.removeClass(this.btn?.nativeElement, 'bounce');
    }, 200);
  }

  showLikeList(postId: number, mode: string) {
    this.mobileService.setIsLikeList(true)
    this.mobileService.setPostId(postId)
    this.mobileService.setMode(mode)
    // var dialog = this.dialog.open(AlertUserLikeListComponent, {
    //   panelClass: 'custom-dialog-container'
    // }
    // )
    this.homeUiService.openNextComponent(AlertUserLikeListComponent,'','alert-like-modal');   
  }
  doLikeUnlike() {
    mixpanel.track('Community-web-Habit post', {'post discription': this.singleRoutineAnswer.commitmentStatement, 'post title': this.singleRoutineAnswer.title, 'post type': this.singleRoutineAnswer.type, 'post id': this.singleRoutineAnswer.id, 'post userid': this.singleRoutineAnswer.user_id, 'post vote': this.singleRoutineAnswer.hasVoted })
      this.render.addClass(this.btn?.nativeElement, 'bounce');
      if (this.btn.nativeElement.querySelector('ion-icon').getAttribute("name") == 'star-outline') {
        this.render.setAttribute(this.btn?.nativeElement.querySelector('ion-icon'), "name", 'star')
      }
      else {
        this.render.setAttribute(this.btn?.nativeElement.querySelector('ion-icon'), "name", 'star-outline')

      }
      setTimeout(() => {
        this.render.removeClass(this.btn?.nativeElement, 'bounce');
      }, 200);
    
    this.onToggleLike.emit({
      item: this.singleRoutineAnswer
    })
  }
  emitShowLikeList(){
    this.onShowLikeList.emit(this.singleRoutineAnswer.id);
  }

  showCommentList(mode: string, id: number) {

    const requestUserList = {
      id: id,
      path_id: this.path.id,
      mode: mode
    }
    this.mobileService.setIsLikeList(false)
    this.mobileService.setRequestUserList(requestUserList)
    this.homeUiService.openNextComponent(AlertUserLikeListComponent,'','alert-like-modal');
    // var dialog = this.dialog.open(AlertUserLikeListComponent, {
    //   panelClass: 'custom-dialog-container'
    // }
    // )
  }

  getRoutineText(routine) {
    if (routine.routineAnswer && routine.routineAnswer.routineDescription) {
      return routine.routineAnswer.routineDescription;
    } else {
      return ''
    }
  }

  getImageUrl(item) {
    if (item && item.user && item.user.image_url) {
      return item.user.image_url
    } else {
      return ''
    }
  }

  getUserName(item) {
    if (item && item.user && item.user.first_name && item.user.last_name) {
      return item.user.first_name + item.user.last_name
    } else {
      return ''
    }
  }



  @HostListener('click', ['$event'])
  onLinkClick(e) {
    console.log("Link data ", e);

    if (e.target.tagName.toLowerCase() === 'a' && e.target.target === '_blank') {
      if (this.cordovaService.onCordova) {
        e.stopPropagation()
        e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target.href)
      } else {
        window.open(e.target.href, '_blank')
      }
    }
   if(e.target.tagName.toLowerCase() === 'span' || e.target.tagName.toLowerCase()=='strong'){
      if (e?.target?.id || e.target?.parentElement.id) {
        this.getUserData(e, e.target.id? e.target.id: e.target?.parentElement.id);
      }
    }
  }
  getUserData(event, id) {
    this.routineService.getUserDetailsById(id).subscribe(value => {
      this.openuserInfo(event, value.data[0]);
    });
  }
  async openuserInfo(ev, userData): Promise<void> {
    if (!this.isHomeRoute) {
      const popover = await this.popoverController.create({
        component: UserPublicProfileComponent,
        event: ev,
        mode: "ios",
        translucent: false,
        componentProps: { user: userData },
      });
      await popover.present();
    }     
  }

  onClick(): void {
    this.h1?.nativeElement.scrollIntoView({
      top: this.h1?.nativeElement.offsetTop,
      behavior: 'smooth',
      block: 'nearest'
    });
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    const offset = this.window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (offset > 100) {
      this.isScrolledBottom = true
    } else {
      this.isScrolledBottom = false
    }
  }

  async getRoutineDetails(val?,isPostDeleted=false): Promise<any> {
    if (!this.singleRoutineAnswer) {
      this.spinnerService.off()
      return
    }
   return new Promise( async (resolve, reject) => {
    try {
      let data, replyId =null;
      if (this.focusSpecificCommentPost?.post?.id == this.data?.id && this.focusSpecificCommentPost?.replyId && this.focusSpecificCommentPost?.replyId != undefined && (this.focusSpecificCommentPost?.post?.replies?.length > 0 && this.focusSpecificCommentPost?.post?.replies[0]?.id == this.focusSpecificCommentPost?.replyId)) {
        replyId= this.focusSpecificCommentPost?.replyId
      }
      if (replyId) {
        data = {
          id: this.singleRoutineAnswer.routine_info_id,
          routine_answer_id: this.singleRoutineAnswer.id,
          mode: this.singleRoutineAnswer.type,
          path_id: this.path.id,
          page:this.page,
          reply_id: replyId
        }
      }
      else {
         data = {
          id: this.singleRoutineAnswer.routine_info_id,
          routine_answer_id: this.singleRoutineAnswer.id,
          mode: this.singleRoutineAnswer.type,
          path_id: this.path.id,
          page:this.page
        }
      }
      await this.routineV2Service.getAllPostsRepliyDetails(data).subscribe(
        (response) => {
          if(this.appState.get('isAnimationApplied'))
          {
            this.isLoaded =true;
          }
          var level1;
             if(this.page ==1 || isPostDeleted) {
                this.apiReplyCount = 0;
               this.repliesTree = [];
             }
            if (this.page == 1 && response.data.replies?.length > 0) {
              this.repliesTree = [];
              level1 = response.data.replies;
            }
            else if (response.data.replies?.length > 0) {
              level1 = this.repliesTree.concat(response.data.replies);
            }          
          this.userDetails = response.data.user;
           this.userDetails.user_bg_color= response?.data?.routine_color
          this.replyCount = response.data.replyCount;
          this.data.replyVotesCount = response.data?.voteCount;
          this.data.replyCount = response.data?.replyCount;
          this.apiReplyCount = this.apiReplyCount + response.data.replies?.length;
          this.singleRoutineAnswer.replyVotesCount= response.data?.voteCount;
          this.singleRoutineAnswer.replyCount = response.data?.replyCount;
          if (level1) {
            var subReply = level1.filter(item => item.repliableId)
            level1?.forEach(reply => {
              subReply?.forEach(element => {
                if (element?.repliableId === reply.id) {
                  reply.replies.push(element)
                }
                reply.timestamp = new Date(reply.createdAt)
              });
            });

            this.repliesTree = level1.filter(reply => reply.id && (reply.replyLevel === 1 || reply.level === 1))
            this.cdRef.detectChanges();
            this.page = this.page + 1
            if (val == false) {
              this.select(val)
            }
            else if (val == true) {
              this.showRecords();
            }
            this.singleRoutineAnswer.replies = this.repliesTree;
            this.data.replies =this.repliesTree;
            console.log("repliescount", this.repliesTree)
            this.appState.set('repliesLength', this.repliesTree?.length)
            this.markRepliesSynced();
            let isCommentDeleted = this.appState.get('commentDeleted')
            if (isCommentDeleted) {
              this.appState.set('commentDeleted', false)
            }
          }
         
          this.spinnerService.off()
        },
        (error) => {
          console.log('error', error)
          if(this.appState.get('isAnimationApplied'))
          {
            this.isLoaded =true;
          }
          this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
          this.spinnerService.off()
        }
      )
      // this.cdRef.detectChanges();
      resolve(true);
    } catch (error) {
      console.log('error', error)
      if(this.appState.get('isAnimationApplied'))
      {
        this.isLoaded =true;
      }
      reject(error);
      this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
      this.spinnerService.off()
    }

  });
  }

  getAllReplies(val?,isPostDeleted=false) : Promise<any>{
    return new Promise(async (resolve, reject) => {
    try {
      let data, replyId =null;
     console.log("🚀 ~ HabitCommentListWebComponent ~ getAllReplies ~ this.data:", this.data)
     if (this.focusSpecificCommentPost?.post?.id == this.data?.id && this.focusSpecificCommentPost?.replyId && this.focusSpecificCommentPost?.replyId != undefined && (this.focusSpecificCommentPost?.post?.replies?.length > 0 && this.focusSpecificCommentPost?.post?.replies[0]?.id == this.focusSpecificCommentPost?.replyId)) {
        replyId= this.focusSpecificCommentPost?.replyId
     }
     console.log('replyId', replyId)
     console.log('this.data', this.data)
      if (replyId) {
        data = {
           screenContentId: replyId,
            path_id: this.path.id,
            page: this.page,
            user_id: this.data?.user_id,
            habit_id: this.data?.habit_id
        }
      }
      else {
         data = {
           screenContentId: this.data?.screenContentId,
            path_id: this.path.id,
            page: this.page,
            user_id: this.data?.user_id,
            habit_id: this.data?.habit_id
        }
      }

      await this.routineV2Service.getKyperPostRepliyDetailsById(data).subscribe(
        (response) => {
          if (this.appState.get("isAnimationApplied")) {
           this.isLoaded = true;
         }
         console.log("🚀 ~ CommentsListWebComponent ~ getAllReplies ~ response.replies:", response.replies)
         var level1;
         if (this.page == 1 || isPostDeleted) {
           this.apiReplyCount = 0;
           this.repliesTree = [];
         }
         if (this.page == 1 && response.replies[0].userAnswers?.length > 0) {
           this.repliesTree = [];
           level1 = response.replies[0].userAnswers;
           console.log("🚀 ~ CommentsListWebComponent ~ getAllReplies ~ level1:", level1)
         } else if (response.replies[0].userAnswers?.length > 0) {
           level1 = this.repliesTree.concat(response.replies[0].userAnswers);
           console.log("🚀 ~ CommentsListWebComponent ~ getAllReplies ~ level1 else:", level1)
         }
         this.replyCount = response.replies[0].replyCount;
         this.data.replyCount = response.replies[0].replyCount;
         const pageItems = response.replies[0].userAnswers?.length ?? 0;
         this.apiReplyCount = this.apiReplyCount + pageItems;
         if (pageItems === 0) { this.apiReplyCount = this.replyCount; }
         if (level1) {
           var subReply = level1.filter((item) => item.repliableId);
           level1.forEach((reply) => {
             subReply?.forEach((element) => {
               if (element?.repliableId === reply.id) {
                 reply.replies?.push(element);
               }
               reply.timestamp = new Date(reply.createdAt);
             });
           });

           this.repliesTree = level1.filter(
             (reply) => reply.id && reply.replyLevel === 1
           );
           this.data.replies = this.repliesTree
           console.log("🚀 ~ CommentsListWebComponent ~ getAllReplies ~ this.data.replies:", this.data.replies)
           this.page = this.page + 1;
           this.appState.set("repliesLength", this.repliesTree.length);
           this.markRepliesSynced();
           if (val == false) {
             this.select(val);
           } else if (val == true) {
             this.showRecords();
           }
         }
       },

       (error) => {
        console.log('error',error)
        this.toastrService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
      }
      )
      resolve(true);
   } catch (error) {
     console.log("error", error);
     if (this.appState.get("isAnimationApplied")) {
       this.isLoaded = true;
     }
     reject(error);
     this.toasterService.error(
       this.i18n.t(
         "Server or connection issue. Please check your internet connection."
       )
     );
    }
   });
  }

  sortRepliesBy(key = 'timestamp') {
    this.repliesTree.sort((a, b) => a[key] > b[key] ? -1 : a[key] < b[key] ? 1 : 0)
    this.cdRef.detectChanges();
  }

  translatePost(language: string,text: any){

    let data = {
      language: language,
      text: text
    }

    this.mobileService.translateContent(data).subscribe(
      (response) => {
        if(response.status){
          this.replyText = response.data.text
          this.cdRef.detectChanges()
          this.toastrService.success(this.i18n.t('Post translated successfully!'))
        }
      },
    (error) => {
      this.toastrService.error(this.i18n.t('Text translation failed!'))
      console.log("TranslationService data ",error);
    }
    )
  }
}
